import Cookies from "js-cookie";

const PROD_BASE_URL = "https://memoryboxco.co.za";
const LOCAL_BASE_URL = "http://localhost:3000";
const PROD_COOKIE_DOMAIN = ".memoryboxco.co.za";

export type AppEnvName = "local" | "production";

export function getAppEnv() {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const envName: AppEnvName = isLocalhost ? "local" : "production";

  return {
    hostname,
    isLocalhost,
    envName,
    shopBaseUrl: isLocalhost ? LOCAL_BASE_URL : PROD_BASE_URL,
    cookieDomain: isLocalhost ? undefined : PROD_COOKIE_DOMAIN
  };
}

export function setEnvCookie(name: string, value: string) {
  const { cookieDomain } = getAppEnv();
  if (cookieDomain) {
    Cookies.set(name, value, { domain: cookieDomain, path: "/" });
  } else {
    Cookies.set(name, value, { path: "/" });
  }
}

export function clearEnvCookie(name: string) {
  const { cookieDomain } = getAppEnv();
  if (cookieDomain) {
    Cookies.remove(name, { domain: cookieDomain, path: "/" });
  } else {
    Cookies.remove(name, { path: "/" });
  }

  // Cleanup legacy cookie variants created before env centralization.
  Cookies.remove(name);
  Cookies.remove(name, { path: "/" });
  Cookies.remove(name, { domain: PROD_COOKIE_DOMAIN, path: "/" });
  Cookies.remove(name, { domain: "localhost", path: "/" });
}
